import { render } from "./EditQ.vue?vue&type=template&id=109d7fee&scoped=true"
import script from "./EditQ.vue?vue&type=script&lang=js"
export * from "./EditQ.vue?vue&type=script&lang=js"

import "./EditQ.vue?vue&type=style&index=0&id=109d7fee&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109d7fee"]])

export default __exports__